<template lang="pug">

  section.box
    h1(data-aos="fade-right" data-aos-delay="300" data-aos-once="true") TRX
    .video(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Video(src="//rudo.video/vod/bGjAVW")
    .text.text1(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Texto
        h2 Entrenamiento funcional que mejora la movilidad, coordinación y flexibilidad
        h4 “Desde que empecé en TRX me recuperé de una parálisis, no me he lesionado en tres años y mi porcentaje de grasa y peso se ha mantenido estable, algo que me costaba mucho”.

        p El TRX es una práctica deportiva muy completa que trabaja todos los grupos musculares del cuerpo. ¿Cuál es su ventaja? Solo con el peso del propio cuerpo es posible trabajar toda la musculatura. Con esto se logra mejorar la capacidad de fuerza, el equilibrio, flexibilidad y elasticidad.

        p Al ser una actividad física muy completa, también contribuye al trabajo de rehabilitación de lesiones. Incluso, las rutinas se pueden adaptar especialmente para personas de la tercera edad, con movilidad reducida y también para personas con discapacidad. Otro de sus beneficios es que potencia la vida saludable, tonifica el cuerpo y potencia la disminución de grasa corporal. Es por esto, que muchas mujeres al ver los rápidos cambios físicos que genera esta práctica deportiva, se han volcado a este nuevo entrenamiento que no requiere de peso extra, por lo que es muy distintivo ver que ellas son mayoría en este deporte.

        p Con el objetivo de potenciar el entrenamiento y brindar un máximo de confort y comodidad, es que Skechers adicionalmente a su línea de zapatillas deportivas, cuenta con una nueva línea de ropa deportiva que destaca por sus diseños en tendencia y su calce perfecto. Acompañando a las mujeres en el TRX.

    .pic-big(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Gal(:pics="['assets/images/trx/01.jpg', 'assets/images/trx/02.jpg']")
    .gal(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Gal(:pics="['assets/images/trx/03.jpg', 'assets/images/trx/04.jpg', 'assets/images/trx/05.jpg']")
    .text2(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Texto
        h2 Una segunda oportunidad en el deporte

        p Desde hace tres años que Valentina Arriagada practica TRX, y también está certificada para dar clases. ¿Cómo partió todo? “Cuando comencé con el TRX no sabía lo que era. Veía videos, pero no entendía para qué servía y por qué iba a incluirlos en mis entrenamientos, ya que desde los 16 años que hago canotaje”, comenta.

        p Desafortunadamente, Valentina conoció el TRX cuando enfrentaba una parálisis que afectaba a la mitad de su cuerpo, y al no poder trabajar con peso extra, empezó a entrenar con la fuerza de su cuerpo y lo aplicó en su deporte. “Desde que empecé en TRX me recuperé de una parálisis, no me he lesionado en tres años y mi porcentaje grasa y peso se ha mantenido estable, algo que me costaba mucho”.

        blockquote “Desde que partí he visto un aumento de mujeres, porque el TRX ayuda a disminuir los niveles de grasa, tonifica, pero lo esencial es que llevas una vida sana y no fuerzas a tu cuerpo más allá de lo que tú puedes. Estás trabajando con tu máximo. Gracias a eso, muchas mujeres han visto los cambios en sus cuerpos”.

        p Encuentra todos sus modelos en tiendas Skechers y <a href="https://www.skechers.cl">Skechers.cl</a>

</template>

<script>
  import Texto from '@/components/skechers/Texto'
  import Pic from '@/components/skechers/Pic'
  import Gal from '@/components/skechers/Gal'
  import Video from '@/components/skechers/Video'

  export default  {
    name: 'trx',
    props: [],
    components: {
      Texto,
      Pic,
      Gal,
      Video
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">

  h1{
    color: #fb2850;
    text-transform: uppercase;
    font-family: 'AvantGarde';
    @include fluid-type(360px, 1440px, 70px, 224px);
    line-height: 90%;
    padding: 0;
    margin: 2rem 0;
    grid-column: 1 / 6;
    position: relative;
    z-index: 2;
    text-align: center;
    &:after,
    &:before{
      content: '';
      position: absolute;
      height: 30px;
      width: 170px;
      background-color: #fb2850;
      @media screen and (max-width: 700px){
        height: 10px;
        width: 80px;
      }
    }
    &:after{
      bottom: calc(100% - 0.5rem);
      right: 0;
      @media screen and (max-width: 700px){
        bottom: calc(100% + 0.5rem);
      }
    }
    &:before{
      top: calc(100% - 0.5rem);
      left: 0;
      @media screen and (max-width: 700px){
        top: calc(100% + 0.5rem);
      }
    }
  }

  .box {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    width: 100%;
    grid-gap: 1rem;
    @media screen and (max-width: 700px){
      padding: 0 1rem;
    }
  }

  .text1{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }

  .pic-big{
    grid-column: 7 / -1;
    margin-top: 0;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }

  .gal{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }
  .video {
    grid-column: 1 / -1;
  }
  .text2{
    grid-column: 7 / -2;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }
  h2{
    margin-bottom: 1rem;
  }

  blockquote{
    font-size: 2rem;
    line-height: 150%;
    padding: 2rem;
    background-color: black;
    color: #fb2850;
  }

</style>
